import { Component, Output, EventEmitter } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { Router } from "@angular/router";
import { HeaderComponent } from "../components/header/header.component";
import { SidebarComponent } from "../components/sidebar/sidebar.component";
import { SubheaderComponent } from "../components/subheader/subheader.component";
import { DropdownModule } from "primeng/dropdown";
import { InputTextModule } from "primeng/inputtext";
import { InputTextareaModule } from "primeng/inputtextarea";
import { CalendarModule } from "primeng/calendar";
import { ButtonModule } from "primeng/button";
import { InputNumberModule } from "primeng/inputnumber";
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { TEU_LOGO_SVG_BLUE } from '../assets/constants';

@Component({
  selector: "app-pending-evaluation",
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    HeaderComponent,
    SidebarComponent,
    SubheaderComponent,
    DropdownModule,
    InputTextModule,
    InputTextareaModule,
    CalendarModule,
    ButtonModule,
    InputNumberModule
  ],
  templateUrl: "./pending-evaluation.component.html",
  styleUrl: "./pending-evaluation.component.css",
})
export class PendingEvaluationComponent {
  constructor(private router: Router, private sanitizer: DomSanitizer) {
    this.logoSvg = this.sanitizer.bypassSecurityTrustHtml(TEU_LOGO_SVG_BLUE);
  }

  @Output() backToWelcome = new EventEmitter<void>();
  @Output() accept = new EventEmitter<void>();

  logoSvg!: SafeHtml;

  goBack(): void {
    this.router.navigate(['/credit-history']);
  }

  onFinish(): void {
    console.log('Proceso completado');
    this.router.navigate(['/welcome']); // Volver al inicio o a donde corresponda
  }

  onAccept(): void {
    this.accept.emit();
  }
}
